import { LIST_ADVERTISERS } from './../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case LIST_ADVERTISERS:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;